import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRoutingModule } from './report-routing.module';
import { CoreModule } from 'app/core/core.module';
import { ReportListComponent } from './components/report-list/report-list.component';
import { ReportComponent } from './pages/report/report.component';
import { SiteListModule } from '@components/site-list/site-list.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { MaterialListModule } from '@components/material-list/material-list.module';

@NgModule({
  imports: [
    ReportRoutingModule,
    CommonModule,
    CoreModule,
    SiteListModule,
    CompanyListModule,
    MaterialListModule
  ],
  declarations: [
    ReportComponent,
    ReportListComponent,
  ]
})
export class ReportModule { }
